/* eslint-disable no-secrets/no-secrets */
import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import metadata from './TinyHomesDetails.metadata.json5';
import messages from './TinyHomesDetails.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import PropertyDetailsComponent from '../subcomponents/PropertyDetails/PropertyDetailsComponent'
import OtherExpoComponent from '../subcomponents/OtherExpo/OtherExpoComponent'

function TinyHomesDetails(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('TinyHomesDetails');

    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true;

    const initializeOtherExpo = () => {
        if (_.isUndefined(modelVM.otherExpo.addResSeaSumFie.value)) {
            _.set(modelVM, 'otherExpo.addResSeaSumFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.busonPreFie.value)) {
            _.set(modelVM, 'otherExpo.busonPreFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.swiPooandorHotTubFie.value)) {
            _.set(modelVM, 'otherExpo.swiPooandorHotTubFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.outMotFie.value)) {
            _.set(modelVM, 'otherExpo.outMotFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.incOffUseFie.value)) {
            _.set(modelVM, 'otherExpo.incOffUseFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.sadorDraAniFie.value)) {
            _.set(modelVM, 'otherExpo.sadorDraAniFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.hobFarFie.value)) {
            _.set(modelVM, 'otherExpo.hobFarFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.incSchDayFie.value)) {
            _.set(modelVM, 'otherExpo.incSchDayFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.tenRooandBoaFie.value)) {
            _.set(modelVM, 'otherExpo.tenRooandBoaFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.golCarFie.value)) {
            _.set(modelVM, 'otherExpo.golCarFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.docliorsupevecomtopreFie.value)) {
            _.set(modelVM, 'otherExpo.docliorsupevecomtopreFie.value', false)
        }

        if (_.isUndefined(modelVM.otherExpo.doyoucarliainsfortelsFie.value)) {
            _.set(modelVM, 'otherExpo.doyoucarliainsfortelsFie.value', false)
        }
    }

    const initializePropertyDetails = () => {
        if (_.isUndefined(modelVM.propertyDetails.conFie.value)) {
            _.set(modelVM, 'propertyDetails.conFie.value', 'Frame')
        }

        if (_.isUndefined(modelVM.propertyDetails.sizofHomIncPorFie.value)) {
            _.set(modelVM, 'propertyDetails.sizofHomIncPorFie.value', 0)
        }

        if (_.isUndefined(modelVM.propertyDetails.wilTinorMinHombetoLocFie.value)) {
            _.set(modelVM, 'propertyDetails.wilTinorMinHombetoLocFie.value', false)
        }

        if (_.isUndefined(modelVM.propertyDetails.undRenFie.value)) {
            _.set(modelVM, 'propertyDetails.undRenFie.value', false)
        }

        if (_.isUndefined(modelVM.propertyDetails.ifAppAnnCorofWooBuBurFie.value)) {
            _.set(modelVM, 'propertyDetails.ifAppAnnCorofWooBuBurFie.value', 0)
        }

        if (_.isUndefined(modelVM.propertyDetails.ifAppAnnBagofPelBuBurFie.value)) {
            _.set(modelVM, 'propertyDetails.ifAppAnnBagofPelBuBurFie.value', 0)
        }

        if (_.isUndefined(modelVM.propertyDetails.othWooBurDevFie.value)) {
            _.set(modelVM, 'propertyDetails.othWooBurDevFie.value', false)
        }

        if (_.isUndefined(modelVM.propertyDetails.disfroFirHydFie.value)) {
            _.set(modelVM, 'propertyDetails.disfroFirHydFie.value', 'Wit300m')
        }

        if (_.isUndefined(modelVM.propertyDetails.distoFirHalFie.value)) {
            _.set(modelVM, 'propertyDetails.distoFirHalFie.value', 'Wit8km')
        }

        if (_.isUndefined(modelVM.propertyDetails.proClaFie.value)) {
            _.set(modelVM, 'propertyDetails.proClaFie.value', 'Pro')
        }

        if (_.isUndefined(modelVM.propertyDetails.auxHeaFie.value)) {
            _.set(modelVM, 'propertyDetails.auxHeaFie.value', 'None')
        }

        if (_.isUndefined(modelVM.propertyDetails.howmanampistheelessysFie.value)) {
            _.set(modelVM, 'propertyDetails.howmanampistheelessysFie.value', '100Amp')
        }

        if (_.isUndefined(modelVM.propertyDetails.sizofLotacrFie.value)) {
            _.set(modelVM, 'propertyDetails.sizofLotacrFie.value', '3acrOrLes')
        }        
    }

    useEffect(() => {
        initializeOtherExpo();
        initializePropertyDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteTinyHomes = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.tinyHomesCoverable.tinyHomes.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        propertyDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.propertyDetails`,
            viewModelService
        },
        otherExpoComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.otherExpo`,
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteTinyHomes
        },
        resolveComponentMap: {
            propertyDetailsComponent: PropertyDetailsComponent,
            otherExpoComponent: OtherExpoComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TinyHomesDetails.propTypes = wizardProps;
export default withRouter(TinyHomesDetails);
